module.exports = {
	"id": "JE",
	"name": "Jersey",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.011222,
			"12": null,
			"13": null,
			"14": null,
			"15": 0.011222,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.016833,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.005611,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": 0.011222,
			"33": 0.022444,
			"34": 0.011222,
			"35": null,
			"36": null,
			"37": null,
			"38": 0.005611,
			"39": 0.033666,
			"40": 0.011222,
			"41": 0.011222,
			"42": null,
			"43": 0.089776,
			"44": 0.050499,
			"45": 0.011222,
			"46": 0.05611,
			"47": 0.011222,
			"48": 0.039277,
			"49": 1.206365,
			"50": 0.050499,
			"51": 0.319827,
			"52": 0.274939,
			"53": 18.90907,
			"54": 4.241916,
			"55": 0.106609,
			"56": 0.039277,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": null,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": 0.033666,
			"10": null,
			"11": null,
			"12": 0.011222,
			"13": null,
			"14": null,
			"15": 0.011222,
			"16": 0.011222,
			"17": null,
			"18": 0.005611,
			"19": 0.028055,
			"20": null,
			"21": 0.005611,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.011222,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": 0.028055,
			"33": 0.061721,
			"34": null,
			"35": null,
			"36": 0.005611,
			"37": null,
			"38": 0.016833,
			"39": 0.005611,
			"40": 0.011222,
			"41": null,
			"42": 0.011222,
			"43": 0.033666,
			"44": 0.022444,
			"45": 0.016833,
			"46": 0.022444,
			"47": 0.162719,
			"48": 0.488157,
			"49": 3.680816,
			"50": 0.179552,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.005611
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.022444,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.011222,
			"37": null,
			"38": null,
			"39": null,
			"40": 0.241273,
			"41": 0.016833,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.022444
		},
		"safari": {
			"0": null,
			"4": 0.061721,
			"5": 0.033666,
			"6": null,
			"7": 0.067332,
			"8": 0.533045,
			"9": 0.555489,
			"10": 4.140918,
			"3.1": null,
			"3.2": null,
			"5.1": 0.331049,
			"6.1": 0.162719,
			"7.1": 0.022444,
			"9.1": 2.614726
		},
		"ios_saf": {
			"8": 0,
			"10": 17.1497562065,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.462166085346,
			"8.1-8.4": 0.853832259367,
			"9.0-9.2": 0.407332820983,
			"9.3": 6.21443662781
		},
		"android": {
			"3": 0,
			"4": 0.0157981317829,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00197476647287,
			"4.1": 0.0569861182171,
			"4.2-4.3": 0.142465295543,
			"4.4": 0.326682796512,
			"4.4.3-4.4.4": 0.329503891473
		},
		"ie": {
			"6": null,
			"7": null,
			"8": 0.246884,
			"9": 0.375937,
			"10": 0.583544,
			"11": 10.391572,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0765772936326,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00212714704535
		},
		"edge": {
			"12": 0.258106,
			"13": 0.690153,
			"14": 2.979441
		},
		"ie_mob": {
			"10": 0.166163830986,
			"11": 0.676524169014
		},
		"bb": {
			"7": 0.057057,
			"10": null
		},
		"samsung": {
			"0": 3.721872
		},
		"and_uc": {
			"0": 0.201894
		},
		"op_mini": {
			"0": 1.03171255932
		},
		"and_chr": {
			"0": 12.102551
		},
		"and_ff": {
			"0": 0.074613
		}
	},
	"total": 98.863442
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/JE.json
 ** module id = 556
 ** module chunks = 0
 **/